import { GridActionsColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import { Classnames } from '@cbridge-utils/mui-theme';

export const ROW_ACTION_ICON_WIDTH = 40;

export const ACTIONS_COL_DEF_PROPS: Omit<GridActionsColDef, 'getActions'> = {
  type: 'actions',
  field: 'actions',
  align: 'right',
  cellClassName: Classnames.VISIBLE_ON_HOVER,
  disableReorder: true,
  hideable: false,
  resizable: false,
};

export const TWO_ACTIONS_COL_DEF_PROPS: Omit<GridActionsColDef, 'getActions'> = {
  ...ACTIONS_COL_DEF_PROPS,
  width: 2 * ROW_ACTION_ICON_WIDTH,
};

export const THREE_ACTIONS_COL_DEF_PROPS: Omit<GridActionsColDef, 'getActions'> = {
  ...ACTIONS_COL_DEF_PROPS,
  width: 3 * ROW_ACTION_ICON_WIDTH,
};

export const FOUR_ACTIONS_COL_DEF_PROPS: Omit<GridActionsColDef, 'getActions'> = {
  ...ACTIONS_COL_DEF_PROPS,
  width: 4 * ROW_ACTION_ICON_WIDTH,
};

export const DEFAULT_ROW_SELECTION_MODEL: GridRowSelectionModel = {
  type: 'include',
  ids: new Set(),
};
